//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Loader from "~/components/loader/loader.vue";
import aos from "~/mixins/aos.js";

export default {
  components: {
    Loader,
  },
  mixins: [aos],
  props: {
    product: {
      required: true,
    },
    createLink: {
      required: true,
    },
    customText: {
      required: false,
    },
    isClient: {
      required: false,
    },
    preview: {
      required: false,
    },
  },
  computed: {
    pageBody() {
      return this.product.page_body;
    },
    cta() {
      let cta;
      if (this.product.hero && this.product.hero.table.cta)
        cta = { title: this.product.hero.table.cta, url: this.createLink };
      else if (this.product.order_type === "Document")
        cta = { title: "Create Document", url: this.createLink };
      else cta = { title: "Get Started", url: this.createLink };
      return cta;
    },
  },
  methods: {
    isComponentVisible(component) {
      if (component.table.fields.table.hide_on_mobile) return "hide-mobile";
      else if (component.table.fields.table.hide_on_desktop)
        return "hide-desktop";
      else return "";
    },
    getTRDataTag(data) {
      if (data.show_only_business_review === true) {
        return "businessformation";
      } else return null;
    },
  },
};
